






import VueOptions from '@utils/VueOptions'
import ChartUtility from '@utils/ChartUtility'
import BoxChart from '@ui/Dashboard/Charts/BoxChart'

settings =
  name: 'PurchaseSamplesDoughnutChart'

  vue:
    props: ['data']

    components: {
      BoxChart,
    }

    data: ->
      chart: null

    methods:
      cleanUp: ->
        @chart?.destroy()

      draw: ->
        data = [
          {
            label: 'Complete'
            value: @data.past
            color: ChartUtility.COLORS.blue
          } if @data.past > 0
          {
            label: 'In Flight'
            value: @data.in_flight
            color: ChartUtility.COLORS.purple
          } if @data.in_flight > 0
          {
            label: 'Planned'
            value: @data.future
            color: ChartUtility.COLORS.green
          } if @data.future > 0
          {
            label: 'Pending'
            value: @data.pending
            color: ChartUtility.COLORS.orange
          } if @data.pending > 0
        ].filter(Boolean)

        @chart = new Chart(@$refs.chart, {
          plugins: [ChartDataLabels]
          type: 'doughnut'
          data: {
            labels: @pluck(data, 'label')
            datasets: [{
              label: 'Samples'
              data: @pluck(data, 'value')
              backgroundColor: @pluck(data, 'color')
              datalabels: {
                labels: {
                  value: {
                    formatter: (value) =>
                      @$options.filters.formatNumberShort value
                    display: (context) =>
                      return 0 unless @data.total
                      value = context.dataset.data[context.dataIndex]
                      value / @data.total > .1
                    color: ChartUtility.COLORS.white
                    font: {
                      weight: 'bold'
                    }
                  }
                  label: {
                    formatter: (value, context) =>
                      context.chart.data.labels[context.dataIndex]
                    color: (context) =>
                      context.dataset.backgroundColor[context.dataIndex]
                    display: (context) =>
                      return 0 unless @data.total
                      value = context.dataset.data[context.dataIndex]
                      value / @data.total > .1
                    offset: 4
                    anchor: 'end'
                    align: 'end'
                    font: {
                      weight: 'bold'
                    }
                  }
                }
              }
            }],
          }
          options: {
            aspectRatio: 1.5
            layout: {
              padding: {
                top: 24
                right: 64
                bottom: 24
                left: 64
              }
            }
            scales: {
              y: {
                display: false
              }
            }
            datasets: {
              doughnut: {
                cutout: '40%'
              }
            }
            plugins: {
              legend: {
                display: false
              }
            }
          }
        })

export default VueOptions.vue settings
